exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#stores-list[data-v-a62fee46]{overflow-y:scroll;overflow-x:hidden;height:480px}", ""]);

// exports
